import { Component, Input } from '@angular/core';
import { HouseFlat } from '../../models/house-flat.model';
import { StreetBuilding } from '../../models/street-building.model';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '../../services/util.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Resident } from '../../models/resident.model';
import { InvitationService } from '../../services/invitation.service';
import { ResidentService } from '../../services/resident.service';
import { IInvitation, Invitation } from '../../models/invitation.model';
import { AppUser } from '../../models/app-user.model';
import * as XLSX from 'xlsx';
import { AuthService } from '../../services/auth.service';
import { UserViewModalComponent } from '../user-view-modal/user-view-modal.component';

@Component({
  selector: 'app-residents-modal',
  templateUrl: './residents-modal.component.html',
  styleUrl: './residents-modal.component.scss'
})
export class ResidentsModalComponent {

  @Input() houseFlat?: HouseFlat;
  @Input() streetBuilding?: StreetBuilding;

  public formInvitation: FormGroup;
  public submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public authService: AuthService,
    private formBuilder: FormBuilder,
    private invitationService: InvitationService,
    private modalService: NgbModal,
    private residentService: ResidentService,
    public utilService: UtilService,
  ) {
    this.formInvitation = this.formBuilder.group({
      email: ['', Validators.required],
    });
  }

  get formControls() {
    return this.formInvitation.controls;
  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR createUser                             */
  /* -------------------------------------------------------------------------- */
  // region createUser
  async createUser() {
    const appUser = await this.residentService.create(
      this.streetBuilding!.neighborhoodId,
      this.streetBuilding!.streetBuildingId,
      this.houseFlat!.houseFlatId
    );

    if(appUser) {
      this.activeModal.close();
      this.openUser(appUser);
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR deleteInvitation                          */
  /* -------------------------------------------------------------------------- */
  // region deleteInvitation
  async deleteInvitation(
    invitation: Invitation
  ) {

    const flag = confirm(
      `¿Estás seguro de eliminar la invitación a ${invitation.email}?`
    );

    if(flag) {
      await this.invitationService.delete(
        this.streetBuilding!.neighborhoodId,
        this.streetBuilding!.streetBuildingId,
        invitation
      );

      this.activeModal.close();
    }

  }

  /* -------------------------------------------------------------------------- */
  /*                            ANCHOR deleteResident                           */
  /* -------------------------------------------------------------------------- */
  // region deleteResident
  async deleteResident(
    resident: Resident
  ) {

    const flag = confirm(
      `¿Estás seguro de eliminar al residente ${resident.resident?.fullName}?`
    );

    if(flag) {
      await this.residentService.delete(
        this.streetBuilding!.neighborhoodId,
        this.streetBuilding!.streetBuildingId,
        resident
      );

      this.activeModal.close();
    }

  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit() {
    this.submitted = true;
    if (this.formInvitation.invalid) {
      return;
    }

    const flag = await this.invitationService.create(
      this.streetBuilding!.neighborhoodId,
      this.streetBuilding!.streetBuildingId,
      this.houseFlat!.houseFlatId,
      this.formInvitation.value,
    )

    if(flag) {
      this.activeModal.close();
    }

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR openUser                              */
  /* -------------------------------------------------------------------------- */
  // region openUser
  openUser(user: AppUser) {

    // console.log('user', user);

    const modalRef = this.modalService.open(
      UserViewModalComponent
    );

    modalRef.componentInstance.user = user;
    modalRef.componentInstance.streetBuilding = this.streetBuilding;
    modalRef.componentInstance.houseFlat = this.houseFlat;

  }

  /*
  ██████╗ ███████╗███████╗███████╗███╗   ██╗██████╗ ██╗███╗   ██╗██╗   ██╗██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗
  ██╔══██╗██╔════╝██╔════╝██╔════╝████╗  ██║██╔══██╗██║████╗  ██║██║   ██║██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║
  ██████╔╝█████╗  ███████╗█████╗  ██╔██╗ ██║██║  ██║██║██╔██╗ ██║██║   ██║██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║
  ██╔══██╗██╔══╝  ╚════██║██╔══╝  ██║╚██╗██║██║  ██║██║██║╚██╗██║╚██╗ ██╔╝██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║
  ██║  ██║███████╗███████║███████╗██║ ╚████║██████╔╝██║██║ ╚████║ ╚████╔╝ ██║   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║
  ╚═╝  ╚═╝╚══════╝╚══════╝╚══════╝╚═╝  ╚═══╝╚═════╝ ╚═╝╚═╝  ╚═══╝  ╚═══╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝

  */
  resendInvitation(
    invitation: any
  ) {
    this.invitationService.create(
      this.streetBuilding!.neighborhoodId,
      this.streetBuilding!.streetBuildingId,
      this.houseFlat!.houseFlatId,
      invitation
    );
  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR restorePassword                           */
  /* -------------------------------------------------------------------------- */
  // REGION restorePassword
  async restorePassword(
    resident: Resident
  ) {

    const user = await this.residentService.restorePassword(
      this.streetBuilding!.neighborhoodId,
      this.streetBuilding!.streetBuildingId,
      resident
    );

    if(user) {
      resident.resident = user;
      if(user.username != "") {
        this.openUser(user);
      }
    }

  }

}
